import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { BookOpen, X } from 'lucide-react';
const NAMES = ['María', 'Carlos', 'Ana', 'Pedro', 'Lucía', 'Diego', 'Valentina', 'Andrés', 'Camila', 'Javier', 'Isabel', 'Santiago', 'Paula', 'Miguel', 'Elena'];
const COUNTRIES = ['México', 'Colombia', 'Argentina', 'España', 'Chile', 'Perú', 'Ecuador', 'Uruguay', 'Bolivia', 'Costa Rica', 'Guatemala', 'República Dominicana'];
export function SocialProofPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentName, setCurrentName] = useState('');
  const [currentCountry, setCurrentCountry] = useState('');
  useEffect(() => {
    const triggerPopup = () => {
      const randomName = NAMES[Math.floor(Math.random() * NAMES.length)];
      const randomCountry = COUNTRIES[Math.floor(Math.random() * COUNTRIES.length)];
      setCurrentName(randomName);
      setCurrentCountry(randomCountry);
      setIsVisible(true);
      // Auto dismiss after 4 seconds
      setTimeout(() => {
        setIsVisible(false);
      }, 4000);
    };
    // Initial delay before first popup
    const initialTimer = setTimeout(triggerPopup, 5000);
    // Random interval between 15-20 seconds for subsequent popups
    const intervalTimer = setInterval(() => {
      triggerPopup();
    }, Math.floor(Math.random() * (20000 - 15000 + 1) + 15000));
    return () => {
      clearTimeout(initialTimer);
      clearInterval(intervalTimer);
    };
  }, []);
  return <AnimatePresence data-id="element-171">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 50,
      x: -20
    }} animate={{
      opacity: 1,
      y: 0,
      x: 0
    }} exit={{
      opacity: 0,
      y: 20,
      scale: 0.9
    }} transition={{
      type: 'spring',
      stiffness: 300,
      damping: 25
    }} className="fixed bottom-4 left-4 md:bottom-8 md:left-8 z-50 max-w-sm bg-cream border border-gold-start/20 rounded-xl shadow-2xl p-4 pr-10 flex items-start gap-4" data-id="element-172">
          <button onClick={() => setIsVisible(false)} className="absolute top-2 right-2 text-brown-light/50 hover:text-brown transition-colors" aria-label="Cerrar notificación" data-id="element-173">
            <X size={16} data-id="element-174" />
          </button>

          <div className="bg-gold-start/10 p-2 rounded-full text-gold-end shrink-0 mt-1" data-id="element-175">
            <BookOpen size={20} data-id="element-176" />
          </div>

          <div data-id="element-177">
            <p className="text-sm font-medium text-brown" data-id="element-178">
              <span className="font-bold" data-id="element-179">{currentName}</span> de{' '}
              {currentCountry}
            </p>
            <p className="text-xs text-brown-light mt-1" data-id="element-180">
              acaba de comprar este programa
            </p>
            <p className="text-[10px] text-brown-light/60 mt-2" data-id="element-181">
              Hace unos momentos
            </p>
          </div>
        </motion.div>}
    </AnimatePresence>;
}